import { proxy } from 'valtio';

export const loginType = {
  password: 'PASSWORD',
  otp: 'OTP',
};

export const loginState = proxy({
  email: '',
  type: 'PASSWORD',
});
